import { ApiError } from '@/api/types'
import { DatePickerWithRange } from '@/entities/datePicker/ui/DatePickerWithRange'
import { MerchantDashboardStatModel } from '@/features/dashboardMerchant/model'
import { StatisticMerchantPanel } from '@/features/dashboardMerchant/ui'
import { BaseCard, BaseTabs } from '@/shared/components'
import { Skeleton } from '@/shared/components/shadcn'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { OptionModel } from '@/shared/lib/types'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { DateRange } from 'react-day-picker'

type Props = {
  statistic: MerchantDashboardStatModel | undefined
  isLoading: boolean
  error: ApiError | null
  tabName: StatisticTabNames
  setTabName: (value: StatisticTabNames) => void
  onDateChange?: (range: DateRange | undefined) => void
}

const tabsButton: OptionModel[] = [
  { label: 'Входящие', value: 'payIn', index: 0 },
  { label: 'Исходящие', value: 'payOut', index: 1 },
]

export const StatisticMerchant = ({
  statistic,
  isLoading,
  error,
  tabName,
  setTabName,
  onDateChange,
}: Props) => {
  const isMobile = useIsMobile()

  const tabComponents = {
    payIn: <StatisticMerchantPanel data={statistic} type="payIn" />,
    payOut: <StatisticMerchantPanel data={statistic} type="payOut" />,
  }

  return (
    <BaseCard padding={isMobile ? 'sm' : 'md'} className="flex flex-col gap-8 w-full">
      {isMobile ? (
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-[10px] mb-4 w-full">
            <div className="font-medium">Статистика</div>
            <BaseTabs
              tabs={tabsButton}
              selectedTab={tabName}
              onSelect={setTabName}
              direction="row"
              variant="secondary"
            />
          </div>
          <div className="flex md:flex-row flex-col md:items-center gap-4 w-full md:w-fit">
            <DatePickerWithRange className="w-full" onDateChange={onDateChange} />
          </div>
        </div>
      ) : (
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4">
            <div className="font-medium">Статистика</div>
            <BaseTabs
              tabs={tabsButton}
              selectedTab={tabName}
              onSelect={setTabName}
              direction="row"
              variant="secondary"
            />
          </div>
          <div className="flex items-center gap-4">
            <DatePickerWithRange className="justify-center" onDateChange={onDateChange} />
          </div>
        </div>
      )}
      {error ? (
        <p>Ошибка загрузки данных.</p>
      ) : isLoading ? (
        <>
          <Skeleton className="mb-6 w-[370px] h-[120px]" />
          <div className="flex md:flex-row flex-col gap-6">
            <Skeleton className="w-[200px] h-[100px]" />
            <Skeleton className="w-[200px] h-[100px]" />
            <Skeleton className="w-[200px] h-[100px]" />
          </div>
        </>
      ) : (
        tabComponents[tabName]
      )}
    </BaseCard>
  )
}
